import React from 'react';
import Heading from '../../heading/heading';
import Footer from '../../footer/footer';
import {Carousel, CarouselItem} from 'react-bootstrap';
import './construction.css';



function Construction() {
  return (
    <div className='construction_page'>
      <Heading />
     <div>
     <div className='construction_content_container'>
        <Carousel>

              <CarouselItem>
                <div className="Carousel_image Carousel_ig_one ">
                   <div className="Carousel_black_background"></div>
                </div>
              <Carousel.Caption>
              <h3 className='contruction_carousel_heading'>
Building Elevation, Survey, &#38; Estimation 
                </h3>
<p className='construction_carousel_caption'>
 If you want to Elevation or Estimate your house you're in right place. We will do everything from the beginning to the end to build the house. And Also we will survey your land or plot with perfect. Contact for more info.
  </p>
              </Carousel.Caption>
              </CarouselItem>

              <CarouselItem>
                <div className="Carousel_image Carousel_ig_two">
                <div className="Carousel_black_background"></div>
                   
                </div>
              <Carousel.Caption>
              <h3 className='contruction_carousel_heading'>
               Highly Skilled Engineers and Employees
                </h3>
<p className='construction_carousel_caption'>
  We have Highly skilled workers. They are ready for your with you. just make a phone call for more info.
  </p>
              </Carousel.Caption>
              </CarouselItem>

              <CarouselItem>
                <div className="Carousel_image  Carousel_ig_three">
                <div className="Carousel_black_background"></div>
                   
                </div>
              <Carousel.Caption>
              <h3 className='contruction_carousel_heading'>
                Building contruction and Renovation
                </h3>
<p className='construction_carousel_caption'>we Are also providing service, which renovating your house with your technical team. Our team is ready to work with you. we will renovate your house without any fault. contact us for more info.
  </p>
              </Carousel.Caption>
              </CarouselItem>

              <CarouselItem>
                <div className="Carousel_image  Carousel_ig_four">
                <div className="Carousel_black_background"></div>
                   
                </div>
              <Carousel.Caption>
              <h3 className='contruction_carousel_heading'>
                2D &#38; 3D Plans
                </h3>
<p className='construction_carousel_caption'>Also, We provide service, which 2d, 3d plans for houses. we will convert your imagination into a full facility home. contact us for more info
  </p>
              </Carousel.Caption>
              </CarouselItem>
        </Carousel>



      </div>
 {/* 
     

2D Plans
The 2D plan will be very innovative, clear and simple with explanations.

Interior Design
We provide creative interior design. We will make the interior design attractive.

Building Estimation
Costs from the beginning to the end of construction will be calculated correctly.

Building Elevation
Elevation will be made clear and neat in your favorite way.

Supervision
The technical plan will be implemented with security and economy.
        */}
            
     </div>
      <Footer />
        </div>)
}

export default Construction